import React, { Component } from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

import { Modal, Button } from 'react-bootstrap';
import api from '../../actions/api';
import NavBarConfig from '../../components/NavBarConfig';


const messages = defineMessages({
  PRODUCTS_AND_PLANS: { id: 'ProductDashboardPage.PRODUCTS_AND_PLANS', defaultMessage: 'Produkte & Tarife' },
  NEW_PRODUCT: { id: 'ProductDashboardPage.NEW_PRODUCT', defaultMessage: 'Neues Produkt' },
  EDIT: { id: 'ProductDashboardPage.EDIT', defaultMessage: 'Bearbeiten' },
  LOADING: { id: 'ProductDashboardPage.LOADING', defaultMessage: 'Lädt...' },
  NO_PRODUCTS_FOUND: { id: 'ProductDashboardPage.NO_PRODUCTS_FOUND', defaultMessage: 'Keine Produkte gefunden. Erstelle dein erstes Produkt!' },
  PLAN_MONTH: { id: 'ProductDashboardPage.PLAN_MONTH', defaultMessage: 'Abo (Monat)' },
  PLAN_YEAR: { id: 'ProductDashboardPage.PLAN_YEAR', defaultMessage: 'Abo (Jahr)' },
  ONE_TIME: { id: 'ProductDashboardPage.ONE_TIME', defaultMessage: 'Einmalig' },
  SINGLE: { id: 'ProductDashboardPage.SINGLE', defaultMessage: 'Single' },
  INCLUDED_USERS: { id: 'ProductDashboardPage.INCLUDED_USERS', defaultMessage: 'Inkludierte User:' },
  UNLIMITED: { id: 'ProductDashboardPage.UNLIMITED', defaultMessage: 'Unlimitiert' },
  CALL_LIMIT: { id: 'ProductDashboardPage.CALL_LIMIT', defaultMessage: 'Anruf-Limit:' },
  MINUTE_LIMIT: { id: 'ProductDashboardPage.MINUTE_LIMIT', defaultMessage: 'Minuten-Limit:' },
  MAX_CONCURRENT_CALLS: { id: 'ProductDashboardPage.MAX_CONCURRENT_CALLS', defaultMessage: 'Max. gleichzeitige Calls:' },
  SMS_LIMIT: { id: 'ProductDashboardPage.SMS_LIMIT', defaultMessage: 'SMS-Limit:' },
  NONE: { id: 'ProductDashboardPage.NONE', defaultMessage: 'Keine' },
  CONFERENCE_FEATURE: { id: 'ProductDashboardPage.CONFERENCE_FEATURE', defaultMessage: 'Konferenz-Feature' },
  INCLUSIVE: { id: 'ProductDashboardPage.INCLUSIVE', defaultMessage: 'Inklusive' },
  SCREENSHARING: { id: 'ProductDashboardPage.SCREENSHARING', defaultMessage: 'Screensharing' },
  CONFERENCE_3_PERSONS: { id: 'ProductDashboardPage.CONFERENCE_3_PERSONS', defaultMessage: 'Konferenz (3 Pers.)' },
  CONFERENCE_5_PERSONS: { id: 'ProductDashboardPage.CONFERENCE_5_PERSONS', defaultMessage: 'Konferenz (5 Pers.)' },
  MODAL_TITLE: { id: 'ProductDashboardPage.MODAL_TITLE', defaultMessage: 'Neues Produkt / Tarif anlegen' },
  PRODUCT_NAME: { id: 'ProductDashboardPage.PRODUCT_NAME', defaultMessage: 'Produktname' },
  TYPE: { id: 'ProductDashboardPage.TYPE', defaultMessage: 'Typ' },
  TYPE_MONTHLY: { id: 'ProductDashboardPage.TYPE_MONTHLY', defaultMessage: 'Abo (Monatlich)' },
  TYPE_YEARLY: { id: 'ProductDashboardPage.TYPE_YEARLY', defaultMessage: 'Abo (Jährlich)' },
  TYPE_ONE_TIME: { id: 'ProductDashboardPage.TYPE_ONE_TIME', defaultMessage: 'Einmalig' },
  LICENSE_MODEL: { id: 'ProductDashboardPage.LICENSE_MODEL', defaultMessage: 'Lizenz-Modell' },
  LICENSE_SINGLE: { id: 'ProductDashboardPage.LICENSE_SINGLE', defaultMessage: 'Einzel-Lizenz (Für genau 1 Account)' },
  LICENSE_POOL: { id: 'ProductDashboardPage.LICENSE_POOL', defaultMessage: 'Pool-Lizenz (Gemeinsames Minuten/Call-Limit für X User)' },
  LICENSE_CONCURRENT: { id: 'ProductDashboardPage.LICENSE_CONCURRENT', defaultMessage: 'Concurrent-Lizenz (Flatrate, aber limitiert auf Y gleichzeitige Calls)' },
  USER_LICENSE_COUNT: { id: 'ProductDashboardPage.USER_LICENSE_COUNT', defaultMessage: 'Anzahl der inkludierten User-Lizenzen (0 = unlimitiert)' },
  CALL_LIMIT_DESC: { id: 'ProductDashboardPage.CALL_LIMIT_DESC', defaultMessage: 'Anruf-Limit (-1 = unlim.)' },
  MINUTE_LIMIT_DESC: { id: 'ProductDashboardPage.MINUTE_LIMIT_DESC', defaultMessage: 'Minuten-Limit (0 = unlim.)' },
  CONCURRENT_CALLS_DESC: { id: 'ProductDashboardPage.CONCURRENT_CALLS_DESC', defaultMessage: 'Max. parallele Calls (Leitungen)' },
  SMS_LIMIT_DESC: { id: 'ProductDashboardPage.SMS_LIMIT_DESC', defaultMessage: 'SMS-Limit (0 = keine)' },
  FREE_PERIOD: { id: 'ProductDashboardPage.FREE_PERIOD', defaultMessage: 'Kostenloser Zeitraum (Tage)' },
  PRICE: { id: 'ProductDashboardPage.PRICE', defaultMessage: 'Preis' },
  CURRENCY: { id: 'ProductDashboardPage.CURRENCY', defaultMessage: 'Währung' },
  STRIPE_PRICE_ID: { id: 'ProductDashboardPage.STRIPE_PRICE_ID', defaultMessage: 'Stripe Price ID (optional)' },
  FEATURE_CONFERENCE: { id: 'ProductDashboardPage.FEATURE_CONFERENCE', defaultMessage: 'Feature: Konferenzschaltung aktivieren' },
  FEATURE_CONFERENCE_DESC: { id: 'ProductDashboardPage.FEATURE_CONFERENCE_DESC', defaultMessage: 'Erlaubt es Kunden mit diesem Tarif, externe Gäste (Dritte) per Gast-Link in laufende Video-Calls einzuladen.' },
  FEATURE_SCREENSHARING: { id: 'ProductDashboardPage.FEATURE_SCREENSHARING', defaultMessage: 'Feature: Screensharing' },
  FEATURE_SCREENSHARING_DESC: { id: 'ProductDashboardPage.FEATURE_SCREENSHARING_DESC', defaultMessage: 'Erlaubt Bildschirmfreigabe innerhalb des Video-Calls.' },
  FEATURE_CONFERENCE_3: { id: 'ProductDashboardPage.FEATURE_CONFERENCE_3', defaultMessage: 'Feature: Konferenz (3 Personen)' },
  FEATURE_CONFERENCE_3_DESC: { id: 'ProductDashboardPage.FEATURE_CONFERENCE_3_DESC', defaultMessage: 'Video-Call mit bis zu 3 Teilnehmern.' },
  FEATURE_CONFERENCE_5: { id: 'ProductDashboardPage.FEATURE_CONFERENCE_5', defaultMessage: 'Feature: Konferenz (5 Personen)' },
  FEATURE_CONFERENCE_5_DESC: { id: 'ProductDashboardPage.FEATURE_CONFERENCE_5_DESC', defaultMessage: 'Video-Call mit bis zu 5 Teilnehmern.' },
  SAVE_PRODUCT: { id: 'ProductDashboardPage.SAVE_PRODUCT', defaultMessage: 'Produkt speichern' },
  SAVING: { id: 'ProductDashboardPage.SAVING', defaultMessage: 'Speichert...' },
  CANCEL: { id: 'ProductDashboardPage.CANCEL', defaultMessage: 'Abbrechen' },
  DELETE: { id: 'ProductDashboardPage.DELETE', defaultMessage: 'Löschen' },
});

class ProductDashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      loading: true,
      error: null,
      showModal: false,
      isSubmitting: false,
      formData: {
        name: '',
        type: 'subscription_monthly',
        license_model: 'single', // single, pool, concurrent
        max_users: 1,
        call_limit: -1,
        minute_limit: 0,
        sms_limit: 0,
        concurrent_limit: 0,
        price: 0,
        currency: 'EUR',
        stripe_price_id: '',
        trial_days: 14,
        feature_conference: 0,
        feature_screensharing: 0,
        feature_conference_3: 0,
        feature_conference_5: 0
      }
    };
  }

  componentDidMount() {
    this.fetchProducts();
  }

  fetchProducts = () => {
    api.get({ url: '/api/product' })
      .then(response => {
        this.setState({ products: response.results || [], loading: false });
      })
      .catch(error => {
        this.setState({ error: 'Fehler beim Laden der Produkte', loading: false });
      });
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
      }
    }));
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });
    
    const { formData, editId } = this.state;
    // Reset irrelevant fields based on license_model to avoid garbage data
    const payload = {
      ...formData,
      is_pool: formData.license_model === 'pool' ? 1 : 0,
      max_users: formData.license_model !== 'single' ? parseInt(formData.max_users, 10) : 1,
      call_limit: formData.license_model !== 'concurrent' ? parseInt(formData.call_limit, 10) : 0,
      minute_limit: formData.license_model !== 'concurrent' ? parseInt(formData.minute_limit, 10) : 0,
      concurrent_limit: formData.license_model === 'concurrent' ? parseInt(formData.concurrent_limit, 10) : 0,
      sms_limit: parseInt(formData.sms_limit, 10),
      price: parseFloat(formData.price),
      trial_days: parseInt(formData.trial_days, 10),
      feature_conference: parseInt(formData.feature_conference, 10),
      feature_screensharing: parseInt(formData.feature_screensharing, 10),
      feature_conference_3: parseInt(formData.feature_conference_3, 10),
      feature_conference_5: parseInt(formData.feature_conference_5, 10)
    };

    const request = editId 
      ? api.put({ url: `/api/product/${editId}`, data: payload })
      : api.post({ url: '/api/product', data: payload });

    request
      .then(() => {
        this.setState({ showModal: false, isSubmitting: false, editId: null });
        this.fetchProducts(); // Refresh list
      })
      .catch(err => {
        alert('Fehler beim Speichern des Produkts');
        this.setState({ isSubmitting: false });
      });
  }

  handleEdit = (product) => {
    this.setState({
      showModal: true,
      editId: product.id,
      formData: {
        name: product.name,
        type: product.type,
        license_model: product.license_model || 'single',
        max_users: product.max_users,
        call_limit: product.call_limit,
        minute_limit: product.minute_limit,
        sms_limit: product.sms_limit,
        concurrent_limit: product.concurrent_limit,
        price: product.price,
        currency: product.currency,
        stripe_price_id: product.stripe_price_id || '',
        trial_days: product.trial_days || 14,
        feature_conference: product.feature_conference ? 1 : 0,
        feature_screensharing: product.feature_screensharing ? 1 : 0,
        feature_conference_3: product.feature_conference_3 ? 1 : 0,
        feature_conference_5: product.feature_conference_5 ? 1 : 0
      }
    });
  }

  handleDelete = (product) => {
    if (window.confirm(`Möchtest du das Produkt "${product.name}" wirklich löschen?`)) {
      api.delete({ url: `/api/product/${product.id}` })
        .then(() => this.fetchProducts())
        .catch(err => alert('Fehler beim Löschen des Produkts'));
    }
  }

  render() {
    const { products, loading, error, showModal, formData, isSubmitting } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
        <NavBarConfig 
          currentRouteName={this.props.routes ? this.props.routes[this.props.routes.length - 1].name : 'products'} 
        />
        <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--text-color)' }}>
            {formatMessage(messages.PRODUCTS_AND_PLANS)}
          </h1>
          <button 
            onClick={() => this.setState({ showModal: true, editId: null, formData: { name: '', type: 'subscription_monthly', license_model: 'single', max_users: 1, call_limit: -1, minute_limit: 0, sms_limit: 0, concurrent_limit: 0, price: 0, currency: 'EUR', stripe_price_id: '', trial_days: 14, feature_conference: 0, feature_screensharing: 0, feature_conference_3: 0, feature_conference_5: 0 } })}
            style={{ 
            padding: '10px 20px', 
            backgroundColor: '#3b82f6', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }}>
            <i className="fa fa-plus" style={{ marginRight: '8px' }} />
            {formatMessage(messages.NEW_PRODUCT)}
          </button>
        </div>

        {error && <div style={{ color: 'red', marginBottom: '16px' }}>{error}</div>}

        {loading ? (
          <div>{formatMessage(messages.LOADING)}</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
            {products.map(product => (
              <div key={product.id} style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                {/* Glow Aura */}
                <div style={{ position: 'absolute', top: '-10px', left: '-10px', right: '-10px', bottom: '-10px', background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(147, 51, 234, 0.15) 100%)', filter: 'blur(20px)', zIndex: 0, borderRadius: '32px' }} />
                
                <div style={{ 
                  position: 'relative',
                  zIndex: 1,
                  backgroundColor: 'var(--panel-bg)', 
                  border: '1px solid var(--panel-border)', 
                  borderRadius: '24px', 
                  padding: '24px',
                  boxShadow: 'var(--glass-shadow)',
                  display: 'flex',
                  flexDirection: 'column',
                  flex: 1
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
                  <div>
                    <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', color: 'var(--text-color)' }}>{product.name}</h3>
                    <span style={{ fontSize: '12px', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      {product.type === 'subscription_monthly' ? 'Abo (Monat)' : product.type === 'subscription_yearly' ? 'Abo (Jahr)' : formatMessage(messages.ONE_TIME)} • {product.price} {product.currency}
                    </span>
                  </div>
                  <div style={{ padding: '4px 8px', backgroundColor: product.license_model === 'pool' ? '#ecfdf5' : product.license_model === 'concurrent' ? '#eef2ff' : '#fef2f2', color: product.license_model === 'pool' ? '#059669' : product.license_model === 'concurrent' ? '#4f46e5' : '#dc2626', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold', textTransform: 'capitalize' }}>
                    {product.license_model || formatMessage(messages.SINGLE)}
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px', color: 'var(--text-color)' }}>
                  {product.license_model !== 'single' && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: 'var(--text-muted)' }}>{formatMessage(messages.INCLUDED_USERS)}</span>
                      <span>{product.max_users === 0 ? formatMessage(messages.UNLIMITED) : product.max_users}</span>
                    </div>
                  )}
                  {product.license_model !== 'concurrent' && (
                    <>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: 'var(--text-muted)' }}>{formatMessage(messages.CALL_LIMIT)}</span>
                        <span>{product.call_limit === -1 ? formatMessage(messages.UNLIMITED) : product.call_limit}</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span style={{ color: 'var(--text-muted)' }}>{formatMessage(messages.MINUTE_LIMIT)}</span>
                        <span>{product.minute_limit === 0 ? formatMessage(messages.UNLIMITED) : product.minute_limit}</span>
                      </div>
                    </>
                  )}
                  {product.license_model === 'concurrent' && (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <span style={{ color: 'var(--text-muted)' }}>{formatMessage(messages.MAX_CONCURRENT_CALLS)}</span>
                      <span>{product.concurrent_limit === 0 ? formatMessage(messages.UNLIMITED) : product.concurrent_limit}</span>
                    </div>
                  )}
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ color: 'var(--text-muted)' }}>{formatMessage(messages.SMS_LIMIT)}</span>
                    <span>{product.sms_limit === 0 ? formatMessage(messages.NONE) : product.sms_limit}</span>
                  </div>
                  {product.feature_conference === true && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#10b981', fontWeight: 'bold' }}>
                      <span><i className="fa fa-users" style={{ marginRight: '6px' }} />{formatMessage(messages.CONFERENCE_FEATURE)}</span>
                      <span>{formatMessage(messages.INCLUSIVE)}</span>
                    </div>
                  )}
                  {product.feature_screensharing === true && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#10b981', fontWeight: 'bold' }}>
                      <span><i className="fa fa-desktop" style={{ marginRight: '6px' }} />{formatMessage(messages.SCREENSHARING)}</span>
                      <span>{formatMessage(messages.INCLUSIVE)}</span>
                    </div>
                  )}
                  {product.feature_conference_3 === true && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#10b981', fontWeight: 'bold' }}>
                      <span><i className="fa fa-phone" style={{ marginRight: '6px' }} />Konferenz (3 Pers.)</span>
                      <span>{formatMessage(messages.INCLUSIVE)}</span>
                    </div>
                  )}
                  {product.feature_conference_5 === true && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', color: '#10b981', fontWeight: 'bold' }}>
                      <span><i className="fa fa-phone-square" style={{ marginRight: '6px' }} />Konferenz (5 Pers.)</span>
                      <span>{formatMessage(messages.INCLUSIVE)}</span>
                    </div>
                  )}
                </div>

                <div style={{ marginTop: '24px', display: 'flex', gap: '8px' }}>
                  <button onClick={() => this.handleEdit(product)} style={{ flex: 1, padding: '8px', backgroundColor: '#f3f4f6', border: '1px solid #e5e7eb', borderRadius: '6px', color: '#374151', cursor: 'pointer' }}>{formatMessage(messages.EDIT)}</button>
                  <button onClick={() => this.handleDelete(product)} title={formatMessage(messages.DELETE)} style={{ padding: '8px 12px', backgroundColor: '#fef2f2', border: '1px solid #fee2e2', borderRadius: '6px', color: '#dc2626', cursor: 'pointer' }}>
                    <i className="fa fa-trash" />
                  </button>
                </div>
              </div>
            </div>
            ))}
            
            {products.length === 0 && (
              <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '48px', color: 'var(--text-muted)' }}>
                {formatMessage(messages.NO_PRODUCTS_FOUND)}
              </div>
            )}
          </div>
        )}

        {/* Modal for Creating Product */}
        <Modal show={showModal} onHide={() => this.setState({ showModal: false })}>
          <form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>{formatMessage(messages.NEW_PRODUCT)} / Tarif anlegen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row">
                <div className="col-md-8 form-group">
                  <label>{formatMessage(messages.PRODUCT_NAME)}</label>
                  <input type="text" className="form-control" name="name" value={formData.name} onChange={this.handleInputChange} required />
                </div>
                <div className="col-md-4 form-group">
                  <label>{formatMessage(messages.TYPE)}</label>
                  <select className="form-control" name="type" value={formData.type} onChange={this.handleInputChange}>
                    <option value="subscription_monthly">Abo (Monatlich)</option>
                    <option value="subscription_yearly">Abo (Jährlich)</option>
                    <option value="one_time">{formatMessage(messages.TYPE_ONE_TIME)}</option>
                  </select>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 form-group">
                  <label>{formatMessage(messages.LICENSE_MODEL)}</label>
                  <select className="form-control" name="license_model" value={formData.license_model} onChange={this.handleInputChange} style={{ fontWeight: 'bold' }}>
                    <option value="single">Einzel-Lizenz (Für genau 1 Account)</option>
                    <option value="pool">Pool-Lizenz (Gemeinsames Minuten/Call-Limit für X User)</option>
                    <option value="concurrent">Concurrent-Lizenz (Flatrate, aber limitiert auf Y gleichzeitige Calls)</option>
                  </select>
                </div>
              </div>

              {formData.license_model !== 'single' && (
                <div className="row">
                  <div className="col-md-12 form-group">
                    <label>Anzahl der inkludierten User-Lizenzen (0 = unlimitiert)</label>
                    <input type="number" className="form-control" name="max_users" value={formData.max_users} onChange={this.handleInputChange} />
                  </div>
                </div>
              )}

              <div className="row">
                {formData.license_model !== 'concurrent' && (
                  <>
                    <div className="col-md-6 form-group">
                      <label>Anruf-Limit (-1 = unlim.)</label>
                      <input type="number" className="form-control" name="call_limit" value={formData.call_limit} onChange={this.handleInputChange} />
                    </div>
                    <div className="col-md-6 form-group">
                      <label>Minuten-Limit (0 = unlim.)</label>
                      <input type="number" className="form-control" name="minute_limit" value={formData.minute_limit} onChange={this.handleInputChange} />
                    </div>
                  </>
                )}
                {formData.license_model === 'concurrent' && (
                  <div className="col-md-6 form-group">
                    <label>Max. parallele Calls (Leitungen)</label>
                    <input type="number" className="form-control" name="concurrent_limit" value={formData.concurrent_limit} onChange={this.handleInputChange} />
                  </div>
                )}
                <div className="col-md-6 form-group">
                  <label>SMS-Limit (0 = keine)</label>
                  <input type="number" className="form-control" name="sms_limit" value={formData.sms_limit} onChange={this.handleInputChange} />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 form-group">
                  <label>Kostenloser Zeitraum (Tage)</label>
                  <input type="number" className="form-control" name="trial_days" value={formData.trial_days} onChange={this.handleInputChange} />
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col-md-6 form-group">
                  <label>{formatMessage(messages.PRICE)}</label>
                  <input type="number" step="0.01" className="form-control" name="price" value={formData.price} onChange={this.handleInputChange} required />
                </div>
                <div className="col-md-6 form-group">
                  <label>{formatMessage(messages.CURRENCY)}</label>
                  <select className="form-control" name="currency" value={formData.currency} onChange={this.handleInputChange}>
                    <option value="EUR">EUR (€)</option>
                    <option value="USD">USD ($)</option>
                    <option value="CHF">CHF</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Stripe Price ID (optional)</label>
                <input type="text" className="form-control" name="stripe_price_id" value={formData.stripe_price_id} onChange={this.handleInputChange} />
              </div>

              <hr />

              <div className="row">
                <div className="col-md-12 form-group">
                  <div style={{ backgroundColor: '#f8fafc', padding: '16px', borderRadius: '8px', border: '1px solid #e2e8f0', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <input 
                        type="checkbox" 
                        name="feature_conference" 
                        checked={formData.feature_conference === 1} 
                        onChange={this.handleInputChange} 
                        style={{ width: '20px', height: '20px' }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '15px' }}>{formatMessage(messages.FEATURE_CONFERENCE)}</div>
                        <div style={{ fontSize: '13px', color: '#64748b' }}>Erlaubt es Kunden mit diesem Tarif, externe Gäste (Dritte) per Gast-Link in laufende Video-Calls einzuladen.</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <input 
                        type="checkbox" 
                        name="feature_screensharing" 
                        checked={formData.feature_screensharing === 1} 
                        onChange={this.handleInputChange} 
                        style={{ width: '20px', height: '20px' }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Feature: {formatMessage(messages.SCREENSHARING)}</div>
                        <div style={{ fontSize: '13px', color: '#64748b' }}>{formatMessage(messages.FEATURE_SCREENSHARING_DESC)}</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <input 
                        type="checkbox" 
                        name="feature_conference_3" 
                        checked={formData.feature_conference_3 === 1} 
                        onChange={this.handleInputChange} 
                        style={{ width: '20px', height: '20px' }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Feature: Konferenz (3 Personen)</div>
                        <div style={{ fontSize: '13px', color: '#64748b' }}>{formatMessage(messages.FEATURE_CONFERENCE_3_DESC)}</div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <input 
                        type="checkbox" 
                        name="feature_conference_5" 
                        checked={formData.feature_conference_5 === 1} 
                        onChange={this.handleInputChange} 
                        style={{ width: '20px', height: '20px' }}
                      />
                      <div>
                        <div style={{ fontWeight: 'bold', fontSize: '15px' }}>Feature: Konferenz (5 Personen)</div>
                        <div style={{ fontSize: '13px', color: '#64748b' }}>{formatMessage(messages.FEATURE_CONFERENCE_5_DESC)}</div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </Modal.Body>
            <Modal.Footer>
              <Button onClick={() => this.setState({ showModal: false })}>{formatMessage(messages.CANCEL)}</Button>
              <Button bsStyle="primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? formatMessage(messages.SAVING) : formatMessage(messages.SAVE_PRODUCT)}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

      </div>
      </div>
    );
  }
}

export default connect(state => ({}))(injectIntl(ProductDashboardPage));
